<template>
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ props }">
      <MenuButton
        v-bind="props"
        :text="title"
        :is-active="isActive"
      />
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in menuItems" :key="index">
        <router-link :to="item.path" class="routerLinkNoDecoration">
          <MenuItem :text="getItemText(item.text)" :active="item.active.value"/>
        </router-link>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { MenuItem } from '@es-bill/es-bill-common-components';
import MenuButton from '@/components/atom/MenuButton.vue';

const { t } = useI18n();

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  menuItems: {
    type: Array,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  },
  useTranslationPrefix: {
    type: Boolean,
    default: false
  }
});

function getItemText(text) {
  return props.useTranslationPrefix ? t(text) : t(text);
}
</script>

<script>
export default {
  name: 'DropdownMenu'
}
</script>

<style scoped>
.routerLinkNoDecoration {
  text-decoration: none;
  color: inherit;
}
</style>
